import Modal from './index.js'

export default {
  name: 'vgb-modal',

  props: {
    'name': {
      type: String,
      required: true,
    },
  },

  data: function() {
    return {
      modalName: '',
      isOpen: false,

      visibility: {
        modal: false,
        overlay: false,
      },
    }
  },

  methods: {
    setName: function(name) {
      this.modalName = name
    },

    open(options) {
      this.processOptions(options)

      this.moveElementToTop()
        .then(() => {
          this.beforeOpened()
          this.isOpen = true

          this.$nextTick(() => {
            this.visibility.overlay = true
            this.visibility.modal = true
          })
        })
    },

    close() {
      this.beforeClosed()
      this.visibility.overlay = false
      this.visibility.modal = false
    },

    moveElementToTop() {
      return Promise.resolve()
    },

    processOptions(options) {

    },

    beforeOpened() {
      window.addEventListener('keydown', this.onKeyUp)
      this.$emit('before-opened')

      document.body.classList.add('modal-open')
    },

    beforeClosed() {
      window.removeEventListener('keydown', this.onKeyUp)
      this.$emit('before-closed')

      document.body.classList.remove('modal-open')
    },

    onKeyUp(event) {
      if (event.which === 27 && this.isOpen) {
        this.close()
      }
    },

    afterLeave: function (el) {
      this.isOpen = false
    },
  },

  created: function() {
    this.setName(this.name)
  },

  beforeMount: function() {
    Modal.event.$on('open', (name, params) => {
      if (name === this.modalName) {
        this.open(params)
      }
    })

    Modal.event.$on('close', (name, params) => {
      if (name === this.modalName) {
        this.close(params)
      }
    })

    Modal.event.$on('toggle', (name, params) => {
      if (name === this.modalName) {
        this.toggle(params)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./resources/assets/front/js/components/vgb-modal/script.js